import { render, staticRenderFns } from "./ShippingContractWindow.vue?vue&type=template&id=0630335e&scoped=true&"
import script from "./ShippingContractWindow.vue?vue&type=script&lang=js&"
export * from "./ShippingContractWindow.vue?vue&type=script&lang=js&"
import style0 from "./ShippingContractWindow.vue?vue&type=style&index=0&id=0630335e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0630335e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0630335e')) {
      api.createRecord('0630335e', component.options)
    } else {
      api.reload('0630335e', component.options)
    }
    module.hot.accept("./ShippingContractWindow.vue?vue&type=template&id=0630335e&scoped=true&", function () {
      api.rerender('0630335e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Price/ShippingContract/ShippingContractWindow.vue"
export default component.exports